import { Parser } from 'htmlparser2';
import { isFeatureEnabled } from '../../../../services/Features';
import { getGlossary } from '../../../../services/Glossary';
import { createMountPoint, escapeRegExp, replaceMountPoint } from '../../helper';
import ReplaceHandler from '../../shared/ReplaceHandler';
import GlossaryTermHighlight from './GlossaryTermHighlight';

export const name = 'glossary';
export const defaultProp = true;

const RTE_GLOSSARY_TERM = 'rte-glossary-term';

const toComponent = matched => createMountPoint(RTE_GLOSSARY_TERM, { keyword: matched }, matched);

class Handler extends ReplaceHandler {
    constructor(appendFn, keywords) {
        const regex = new RegExp(
            `\\b(${keywords
                .slice()
                .sort((a, b) => b.length - a.length)
                .map(escapeRegExp)
                .join('|')})\\b`,
            'gi'
        );
        super(appendFn, regex, toComponent);
    }
}

export function onParse(content, enabled) {
    if (!enabled || !isFeatureEnabled('FEATURE_glossary')) {
        return content;
    }
    const keywords = getGlossary().map(term => term.keyword);
    if (!keywords.length) {
        return content;
    }

    let result = '';
    const parser = new Parser(new Handler(s => (result += s), keywords), { decodeEntities: false });
    parser.write(content);
    parser.end();
    return result;
}

export function onMount(node) {
    if (!isFeatureEnabled('FEATURE_glossary')) {
        return undefined;
    }
    return replaceMountPoint(node, RTE_GLOSSARY_TERM, data => <GlossaryTermHighlight keyword={data.keyword} />);
}
